module.exports = __webpack_public_path__ + "img/组 3.19e8958e.webp";